<template>
  <div class="row">
    <div class="col-20 upper-std-wrapper-title">
      {{ $t('view-CampaignsCpcDetails.Report.title') }}
    </div>
    <div class="col-20 std-wrapper mt-0 p-3 px-4 pt-4">
      <div class="row">
        <div class="col-20 col-md-10">
          <clicks-chart
            v-if="reportData"
            :report="reportData"
          />
        </div>
        <div class="col-20 col-md-8 offset-md-2">
          <data-display
            :title="$t('view-CampaignsCpcDetails.Report.legend.all')"
            class="mb-4 d-block"
          >
            {{ reportData.all || 0 }}
          </data-display>
          <data-display
            :title="$t('view-CampaignsCpcDetails.Report.legend.correct')"
            class="mb-4 d-block"
          >
            {{ reportData.correct || 0 }}
          </data-display>
          <data-display
            :title="$t('view-CampaignsCpcDetails.Report.legend.duplicate')"
            class="mb-4 d-block"
          >
            {{ reportData.duplicate || 0 }}
          </data-display>
          <data-display
            :title="$t('view-CampaignsCpcDetails.Report.legend.robots')"
            class="mb-4 d-block"
          >
            {{ reportData.bot || 0 }}
          </data-display>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ClicksChart from './ClicksChart.vue'
import SimpleDataDisplay from '../../../components/SimpleDataDisplay.vue'

export default {
  components: {
    'clicks-chart': ClicksChart,
    'data-display': SimpleDataDisplay
  },
  props: {
    campaign: {
      type: Object,
      default: () => { return {} }
    },
    report: {
      type: Object,
      default: () => { return null }
    }
  },
  data () {
    return {
      loader: true
    }
  },
  computed: {
    reportData () {
      return this.report ? this.report.summary : false
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
